// extracted by mini-css-extract-plugin
module.exports = {"codeEditorArea":"CodeEditorArea_codeEditorArea__3EA1f","codeArea":"CodeEditorArea_codeArea__2ceD7"};